/**
 * The height of height of a standard control (expressed as a number) to be used in CSS.
 * @public
 */
export const heightNumber = '(var(--base-height-multiplier) + var(--density)) * var(--design-unit)';
